import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "left flex f-col"
  }, [_c('div', {
    staticClass: "patient flex row-between"
  }, [_c('span', [_vm._v("患者总数：")]), _c('span', {
    staticClass: "num"
  }, [_vm._v(" " + _vm._s(_vm.source.patientNum ? _vm.source.patientNum.toLocaleString() : 0) + " 人 ")])]), _c('div', {
    staticClass: "evaluate flex row-between"
  }, [_c('span', [_vm._v("评估总次数：")]), _c('span', {
    staticClass: "num"
  }, [_vm._v(" " + _vm._s(_vm.source.pgNum ? _vm.source.pgNum.toLocaleString() : 0) + "次 ")])]), _vm._l(_vm.cards, function (it) {
    return _c('div', {
      key: it.type,
      class: ['card', it.type]
    }, [_c('div', {
      staticClass: "icon"
    }), _c('div', {
      staticClass: "flex1 flex f-col row-between"
    }, [_c('div', {
      staticClass: "row1"
    }, [_c('span', {
      staticClass: "tip"
    }, [_vm._v(_vm._s(it.row1.label))]), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s("".concat(_vm.source[it.row1.key] || 0, " ").concat(it.row1.unit)))])]), _c('div', {
      staticClass: "row2"
    }, [_c('span', {
      staticClass: "tip"
    }, [_vm._v(_vm._s(it.row2.label))]), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s("".concat(_vm.source[it.row2.key] || 0, " ").concat(it.row2.unit)))])])])]);
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };